const imageFileTypes = 'image/png,image/jpg,image/jpeg,image/gif';

export default imageFileTypes;



// WEBPACK FOOTER //
// ./src/config/imageFileTypes.js